/* eslint-disable no-redeclare */
// TODO: remove code above and fix issues in case changing this file

(function () {
	'use strict';
	angular.module('dat.shared-components.location')
		.factory('searchValidator', searchValidator);

	searchValidator.$inject = ['baseValidator', '$q'];

	function searchValidator(baseValidator, $q) {
		var validator = {
			clearValidation: clearValidation,
			validateField: validateField,
			validateAll: validateAll
		};

		return validator;

		function clearValidation(model, field) {
			baseValidator.clearValidation(model, field);
		}

		function validateField(model, fieldName, allowEmptyValue, allowAreas) {
			return validateField(model, fieldName, allowEmptyValue, allowAreas);
		}

		function validateAll(searchModel, allowAreas) {
			var deferred = $q.defer();

			searchModel.originValidation = initialize(searchModel.originValidation);
			searchModel.destinationValidation = initialize(searchModel.destinationValidation);

			$q.all([getOriginPromise(searchModel, allowAreas), getDestinationPromise(searchModel, allowAreas)])
				.then(function (validationResults) {
					var isLocationsValid = handleLocations(searchModel, validationResults[0], validationResults[1], allowAreas);
					deferred.resolve(isLocationsValid);
				});

			return deferred.promise;
		}

		function updateLocationValidationModel(fieldName, searchValidationModel, validationResult) {
			if (validationResult.isValid) {
				searchValidationModel.message = '';
				searchValidationModel.invalid = false;
			} else {
				if (validationResult.isEmpty) {
					searchValidationModel.message = ((fieldName === 'origin' ? 'Origin' : 'Destination') + ' is required');
				} else {
					searchValidationModel.message = validationResult.message;
				}

				searchValidationModel.invalid = true;
			}
		}

		function getFieldPromise(model, fieldName, allowAreas) {
			if (angular.isUndefined(model[fieldName + 'Handle']) || model[fieldName + 'Handle'] === null) {
				return baseValidator.validateLocation(fieldName, model[fieldName], allowAreas);
			} else {
				return baseValidator.makeValidationResultForGivenLocation(model[fieldName + 'Handle'], model[fieldName], model[fieldName + 'IsArea']);
			}
		}

		function getOriginPromise(searchModel, allowAreas) {
			if (angular.isUndefined(searchModel.originHandle) || searchModel.originHandle === null) {
				return baseValidator.validateLocation('origin', searchModel.origin, allowAreas);
			} else {
				return baseValidator.makeValidationResultForGivenLocation(searchModel.originHandle, searchModel.origin, searchModel.originIsArea);
			}
		}

		function getDestinationPromise(searchModel, allowAreas) {
			if (angular.isUndefined(searchModel.destinationHandle) || searchModel.destinationHandle === null) {
				return baseValidator.validateLocation('destination', searchModel.destination, allowAreas);
			} else {
				return baseValidator.makeValidationResultForGivenLocation(searchModel.destinationHandle, searchModel.destination, searchModel.destinationIsArea);
			}
		}

		function handleLocation(model, fieldName, validationResult, allowEmptyField, allowAreas) {
			if (validationResult.isValid) {
				model[fieldName + 'Handle'] = validationResult.locationResolution;
				model[fieldName] = validationResult.formattedLocation;
				if (allowAreas === true && angular.isDefined(model[fieldName + 'IsArea'])) {
					model[fieldName + 'IsArea'] = validationResult.isArea;
				}
			} else {
				model[fieldName + 'Handle'] = null;
			}

			if (validationResult.isEmpty && allowEmptyField === true){
				validationResult.isValid = true;

				return validationResult.isValid;
			}
			if (allowAreas !== true && validationResult.isArea === true){
				validationResult.message = (fieldName === 'origin' ? 'Origin' : 'Destination') + ' ' + validationResult.enteredValue + ' is invalid';
				validationResult.isValid = false;
				updateLocationValidationModel(fieldName, model[fieldName + 'Validation'], validationResult);

				return false;
			}

			if (validationResult.isEmpty)
				reset(model[fieldName + 'Validation']);

			if (validationResult.isEmpty) {
				if (!model[fieldName + 'HasFocus']) {
					updateLocationValidationModel(fieldName, model[fieldName + 'Validation'], validationResult);

					return false;
				}

				return true;
			}

			if (!validationResult.isEmpty || model[fieldName + 'HasFocus']) {
				if (!validationResult.isEmpty)
					updateLocationValidationModel(fieldName, model[fieldName + 'Validation'], validationResult);

				if (validationResult.isEmpty && model[fieldName + 'HasFocus']) {
					return true;
				} else {
					if (validationResult.isEmpty) {
						return validationResult.isValid;
					}
					if (validationResult.isEmpty) {
						return validationResult.isValid;
					}
				}
			}

			return validationResult.isValid;
		}

		function handleLocations(searchModel, originValidationResult, destinationValidationResult, allowAreas) {

			handleLocation(searchModel, 'origin', originValidationResult, allowAreas);
			handleLocation(searchModel, 'destination', destinationValidationResult, allowAreas);

			return originValidationResult.isValid && destinationValidationResult.isValid;
		}

		function reset(validationModel) {
			validationModel.message = null;
		}

		function initialize(validationModel) {
			return validationModel || { message: '', invalid: false };
		}

		function validateField(model, fieldName, allowEmptyValue, allowAreas) {
			var deferred = $q.defer();

			model.originValidation = initialize(model.originValidation);

			$q.all([getFieldPromise(model, fieldName, allowAreas)])
				.then(function (validationResults) {
					var isLocationsValid = handleLocation(model, fieldName, validationResults[0], allowEmptyValue, allowAreas);
					deferred.resolve(isLocationsValid);
				}, function () {
					deferred.reject(false);
				});

			return deferred.promise;
		}
	}
})();
